import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';

const Footer: React.FC = () => (
    <Box component="footer" sx={{ mt: 'auto', pt: 6, pb: 4 }}>
        <Container maxWidth="lg">
            <Divider sx={{ mb: 4 }} />
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    © {new Date().getFullYear()} Aleksandr Pashchenko.
                </Typography>
                <Stack direction="row" spacing={1}>
                    <IconButton href="https://t.me/pashchenko8" target="_blank" size="small" sx={{ borderRadius: '10px' }}><TelegramIcon fontSize="small" /></IconButton>
                    <IconButton href="mailto:aal.pashchenko8@gmail.com" size="small" sx={{ borderRadius: '10px' }}><EmailRoundedIcon fontSize="small" /></IconButton>
                </Stack>
            </Box>
        </Container>
    </Box>
);

export default Footer;
